export default __webpack_public_path__ + "static/media/InductorImg.8f5b8377.jpg";